interface PickupInfoProps {
  customerName: string;
  pickupDatetime: string;
}

const formatPickupDatetime = (isoString: string) => {
  const date = new Date(isoString);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  return date.toLocaleString('ko-KR', options);
};

export default function PickupInfo({ customerName, pickupDatetime }: PickupInfoProps) {
  return (
    <div className="bg-gray-50 rounded-lg p-4 space-y-3">
      <h2 className="text-sm font-semibold text-gray-900">픽업 정보</h2>
      <div className="space-y-2">
        <div className="flex items-start gap-3">
          <span className="text-sm text-gray-600 min-w-[60px]">고객명</span>
          <span className="text-sm font-medium text-gray-900">{customerName}</span>
        </div>
        <div className="flex items-start gap-3">
          <span className="text-sm text-gray-600 min-w-[60px]">픽업 예정</span>
          <span className="text-sm font-medium text-gray-900">{formatPickupDatetime(pickupDatetime)}</span>
        </div>
      </div>
    </div>
  );
}
